import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-end" }
const _hoisted_2 = { class: "slots-item-list" }
const _hoisted_3 = {
  key: 0,
  class: "exceed-info"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SlotItemOverview = _resolveComponent("SlotItemOverview")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredSlotList, (slot) => {
        return (_openBlock(), _createBlock(_component_SlotItemOverview, {
          key: slot,
          objectSlot: slot,
          isAdd: _ctx.isAdd,
          device: _ctx.device,
          linkableObject: _ctx.linkableObject,
          ruleServiceType: _ctx.ruleServiceType
        }, null, 8, ["objectSlot", "isAdd", "device", "linkableObject", "ruleServiceType"]))
      }), 128))
    ]),
    (_ctx.slotsThatExceed > 0)
      ? (_openBlock(), _createBlock("small", _hoisted_3, "+" + _toDisplayString(_ctx.slotsThatExceed), 1))
      : _createCommentVNode("", true)
  ]))
}